import HighchartsVue from 'highcharts-vue';
import Vue from 'vue';

Vue.use(HighchartsVue);
